import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faIdCard, faFileSignature, faFileContract } from '@fortawesome/free-solid-svg-icons'
import { LinkedList } from '/src/components/common'

const items = [
  {
    path: '/community/events-field-days',
    content: <>
      <h3><FontAwesomeIcon icon={faIdCard} /> Events</h3>
    </>
  },
  {
    path: '/community/careers',
    content: <>
      <h3><FontAwesomeIcon icon={faFileSignature} /> Careers</h3>
    </>
  },
  {
    path: '/community/australian-heritage',
    content: <>
      <h3><FontAwesomeIcon icon={faFileContract} /> History</h3>
    </>
  }
]

export const HomeFooterListBlock = (props) => {
  return <LinkedList items={items} {...props} />
}
